import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AuthContext from "../context/AuthContext";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  DateField,
  DatePicker,
  DatePickerToolbar,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Copyright } from "@mui/icons-material";
import { Navigate, redirect } from "react-router-dom";
import { set } from "date-fns";

export const PasswordChangePage = () => {
  const [errorMessage, setErrorMessage] = useState("");

  let { user } = useContext(AuthContext);
  let { logoutUser } = useContext(AuthContext);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget as HTMLFormElement);
    const currentPassword = formData.get("currentPassword") as string;
    const newPassword = formData.get("newPassword") as string;
    const confirmPassword = formData.get("confirmPassword") as string;

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwörter sind nicht identisch.");
      return;
    }

    // Send request to api/change-password with currentPassword and newPassword
    const response = await fetch(`/api/change-password/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: user["user_id"],
        oldPassword: currentPassword,
        newPassword: newPassword,
      }),
    });
    const data = await response.json();

    if (response.ok && data.ok) {
      // Logout user
      logoutUser();
    } else {
      setErrorMessage(
        "Fehler beim Ändern des Passworts. Versuchen Sie es erneut."
      );
      return;
    }

    // Reset form fields
    setErrorMessage("");
  };

  const theme = createTheme();
  return (
    <>
      {user && (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="xs" style={{ marginTop: 100 }}>
            <CssBaseline />
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5">
                Passwort ändern
              </Typography>
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit as any}
                sx={{ mt: 3 }}
              >
                <div style={{ marginBottom: "10px" }}>
                  {errorMessage && (
                    <Typography color="error">{errorMessage}</Typography>
                  )}
                </div>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      type="password"
                      name="currentPassword"
                      required
                      fullWidth
                      id="currentPassword"
                      label="aktuelles Passwort"
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      type="password"
                      name="newPassword"
                      required
                      fullWidth
                      id="newPassword"
                      label="neues Passwort"
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      type="password"
                      name="confirmPassword"
                      required
                      fullWidth
                      id="confirmPassword"
                      label="Passwort bestätigen"
                      autoFocus
                    />
                  </Grid>
                </Grid>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Absenden
                </Button>
              </Box>
            </Box>
            {/* <Copyright sx={{ mt: 5 }} /> */}
          </Container>
        </ThemeProvider>
      )}
    </>
  );
};
